import { store } from 'react-notifications-component';
var buildNotification = function (_a) {
    var title = _a.title, _b = _a.message, message = _b === void 0 ? '' : _b, _c = _a.type, type = _c === void 0 ? 'info' : _c;
    return ({
        title: title,
        message: message,
        type: type,
        insert: 'top',
        container: 'top-right',
        animationIn: ['animated', 'fadeIn'],
        animationOut: ['animated', 'fadeOut'],
        dismiss: {
            duration: 5000,
            onScreen: true,
            pauseOnHover: true,
        },
    });
};
export var notifySuccess = function (_a) {
    var title = _a.title, message = _a.message;
    store.addNotification(buildNotification({ title: title, message: message, type: 'success' }));
};
export var notifyError = function (_a) {
    var title = _a.title, message = _a.message;
    store.addNotification(buildNotification({ title: title, message: message, type: 'danger' }));
};
export var notifyInfo = function (_a) {
    var title = _a.title, message = _a.message;
    store.addNotification(buildNotification({ title: title, message: message, type: 'info' }));
};
//# sourceMappingURL=notification.js.map